import { render, staticRenderFns } from "./MedicalAccordion.vue?vue&type=template&id=79461987&scoped=true&"
import script from "./MedicalAccordion.vue?vue&type=script&lang=js&"
export * from "./MedicalAccordion.vue?vue&type=script&lang=js&"
import style0 from "./MedicalAccordion.vue?vue&type=style&index=0&id=79461987&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79461987",
  null
  
)

export default component.exports